// Quick follow-up email templates. {{firstName}} / {{state}} are filled in
// server-side per lead by POST /leads/:id/email.

export const EMAIL_TEMPLATES = [
  {
    id: 'appointment',
    label: 'Appointment Confirmation',
    subject: 'Your appointment is confirmed',
    body: 'Hi {{firstName}},\n\nThanks for speaking with me. This confirms the appointment we just scheduled. Reply here if you need to change the time.\n\nTalk soon!',
  },
  {
    id: 'info',
    label: 'Information Requested',
    subject: 'The information you asked for',
    body: 'Hi {{firstName}},\n\nGreat chatting with you. As promised, here is the information you requested. Let me know if you have any questions.\n\nBest regards',
  },
  {
    id: 'voicemail',
    label: 'Voicemail Follow-up',
    subject: 'Sorry I missed you',
    body: 'Hi {{firstName}},\n\nI just tried reaching you by phone and left a voicemail. When is a good time to connect? You can reply here or call me back.\n\nThanks!',
  },
];
